export default abstract class DomainEntityBase {}
